import React, { useState } from 'react';
import './Navigation.css';

const Navigation = ({ 
  onNavigateToHome,
  onNavigateToBrowseRFQs,
  onNavigateToPostRFQ,
  onNavigateToContact,
  onNavigateToBusinessContact,
  currentPage,
  user,
  onSignIn,
  onSignOut
}) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleLoginClick = () => {
    setMobileMenuOpen(false);
    if (onSignIn) {
      onSignIn('freelancer');
    }
  };

  const handleNavClick = (navigateFunc) => {
    setMobileMenuOpen(false);
    if (navigateFunc) {
      navigateFunc();
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        {/* Logo */}
        <div className="nav-logo" onClick={() => handleNavClick(onNavigateToHome)}>
          <img 
            src="https://i.ibb.co/jk4rbQ7g/download-logo.png" 
            alt="Global Expedyte Logo" 
            className="logo-image"
          />
          <div className="logo-text">
            <span className="logo-name">GLOBAL EXPEDYTE</span>
            <span className="logo-tagline">Project Marketplace</span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
          <button
            onClick={() => handleNavClick(onNavigateToHome)}
            className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
          >
            Home
          </button>

          <button
            onClick={() => handleNavClick(onNavigateToBrowseRFQs)}
            className={`nav-link ${currentPage === 'browse-rfqs' ? 'active' : ''}`}
          >
            Projects
          </button>
          
          <button
            onClick={() => handleNavClick(onNavigateToContact)}
            className={`nav-link ${currentPage === 'contact' ? 'active' : ''}`}
          >
            Contact
          </button>

          {/* User Section / Login */}
          {user ? (
            <div className="user-section">
              <span className="user-name">Welcome, {user.firstName}</span>
              <button onClick={onSignOut} className="btn-logout">
                Sign Out
              </button>
            </div>
          ) : (
            <div className="auth-buttons">
              <button 
                onClick={() => handleNavClick(onNavigateToBusinessContact)}
                className="btn-business"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
                  <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
                </svg>
                For Businesses
              </button>
              <button 
                onClick={handleLoginClick}
                className="btn-login"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                Login
              </button>
            </div>
          )}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {mobileMenuOpen ? (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="3" y1="12" x2="21" y2="12"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          )}
        </button>
      </div>
    </nav>
  );
};

export default Navigation;